/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fc_Dl_Macos_S4Inputs */

const en_fc_dl_macos_s4 = /** @type {(inputs: Fc_Dl_Macos_S4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`FilmCraft opens with a demo project so you can explore the panels right away.`)
};

/**
* | output |
* | --- |
* | "FilmCraft opens with a demo project so you can explore the panels right away." |
*
* @param {Fc_Dl_Macos_S4Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const fc_dl_macos_s4 = /** @type {((inputs?: Fc_Dl_Macos_S4Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fc_Dl_Macos_S4Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_fc_dl_macos_s4(inputs)
});
export { fc_dl_macos_s4 as "fc.dl.macos.s4" }